module.exports = __webpack_public_path__ + "static/pizza_5-3ba3f1e2e37a2a815b6cbf7b5f2435ef.jpg";